/* Native details and facets own navigation; this only manages the quick menus. */
(() => {
  if (window.EvolvedQuickFilters) return;
  window.EvolvedQuickFilters = true;
  document.addEventListener('click', (event) => {
    const more = event.target.closest?.('.ev-quick-filter__more');
    if (more) {
      const group = more.closest('.ev-quick-filter');
      group.setAttribute('data-show-all', '');
      more.setAttribute('aria-expanded', 'true');
      group.querySelector('.ev-quick-filter__extra')?.focus();
      return;
    }
    document.querySelectorAll('.ev-quick-filter[open]').forEach((group) => {
      if (!group.contains(event.target)) group.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest?.('.ev-quick-filter[open]');
    if (group) { group.removeAttribute('open'); group.querySelector('summary')?.focus(); }
  });
})();
